import * as Yup from 'yup';

export const AnnouncementValidation = Yup.object({
  isInternal: Yup.boolean(),
  title: Yup.string()
    .min(1, 'Title must be at least 1 character long')
    .max(255, 'Title must not exceed 255 characters')
    .required('Title is required'),
  description: Yup.string()
    .min(1, 'Description must be at least 1 character long')
    .max(1000, 'Description must not exceed 1000 characters')
    .required('Description is required'),
  link: Yup.string()
    .url('Please enter a valid URL')
    .optional()
    .nullable(),
  scheduledAt: Yup.date().nullable().optional(),
  url: Yup.string().optional().nullable(),
  bookId: Yup.string().when('isInternal', {
    is: true,
    then: (schema) => schema.required('Book is required'),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  chapterId: Yup.string().when('isInternal', {
    is: true,
    then: (schema) => schema.required('Chapter is required'),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  pageNo: Yup.number().when('isInternal', {
    is: true,
    then: (schema) =>
      schema
        .typeError('Page number is required')
        .required('Page number is required')
        .positive('Page number must be greater than 0')
        .integer('Page number must be a whole number'),
    otherwise: (schema) => schema.optional().nullable(),
  }),
  searchQuery: Yup.string().when('isInternal', {
    is: true,
    then: (schema) => schema.optional().nullable(),
    otherwise: (schema) => schema.optional().nullable(),
  }),
});
